module.exports = __webpack_public_path__ + "media/games-3.00e4147e.mp4";